import { Box, Autocomplete, TextField } from "@mui/material";

const ProviderReferralEditor = ({
  showReferralTo,
  showReferralFrom,
  showReferralNote,
  providers,
  selectedProvider,
  selectedReferralTo,
  selectedReferralFrom,
  handleProviderChange,
  handleReferralToChange,
  handleReferralFromChange,
  rowId,
}) => {
  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      gap={0.5}
      p={1}
      sx={{
        overflow: "visible",
      }}
    >
      {showReferralNote && (
        <Box
          sx={{
            backgroundColor: "#fff9c4",
            color: "#000",
            fontSize: "0.75rem",
            padding: "0.5rem 0.75rem",
            borderRadius: "4px",
            boxSizing: "border-box",
            maxWidth: "100%",
            overflow: "visible",
            whiteSpace: "normal",
            lineHeight: 1.4,
            mb: 1,
          }}
        >
          <strong>NOTE:</strong> Only providers that are already assigned to the client's case can
          be chosen below. If the provider needed is not shown below, please add them to the case
          before uploading the referral file.
        </Box>
      )}

      {
        <Autocomplete
          size="small"
          className="flex w-full items-center"
          options={providers}
          getOptionLabel={(option) => option.name || ""}
          value={selectedProvider || null}
          onChange={(e, value) => handleProviderChange(rowId, value)}
          renderInput={(params) => <TextField {...params} label="Related Provider" size="small" />}
          ListboxProps={{ style: { zIndex: 1050 } }}
          PopperProps={{ style: { zIndex: 1050 } }}
        />
      }

      {(showReferralTo || showReferralFrom) && (
        <Box display="flex" gap={1}>
          {showReferralTo && (
            <Autocomplete
              size="small"
              fullWidth
              options={providers}
              getOptionLabel={(option) => option.name || ""}
              value={selectedReferralTo || null}
              onChange={(e, value) => handleReferralToChange(rowId, value)}
              renderInput={(params) => <TextField {...params} label="Referred To" size="small" />}
              ListboxProps={{ style: { zIndex: 1050 } }}
              PopperProps={{ style: { zIndex: 1050 } }}
            />
          )}
          {showReferralFrom && (
            <Autocomplete
              size="small"
              fullWidth
              options={providers}
              getOptionLabel={(option) => option.name || ""}
              value={selectedReferralFrom || null}
              onChange={(e, value) => handleReferralFromChange(rowId, value)}
              renderInput={(params) => <TextField {...params} label="Referred From" size="small" />}
              ListboxProps={{ style: { zIndex: 1050 } }}
              PopperProps={{ style: { zIndex: 1050 } }}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default ProviderReferralEditor;
